import type { UseMutationResult } from "@tanstack/react-query";
import {
    usePerformBoOperationMutation,
    type PerformBoOperationVariables,
} from "@src/businessModules/WorkShop/shared/bo/usePerformBoOperationMutation";

export interface UseWsLimitCardMutationsParams {
    onBoOperationSuccess: () => void;
}

export interface UseWsLimitCardMutationsResult {
    performBoOperationMutation: UseMutationResult<void, Error, PerformBoOperationVariables>;
}

/**
 * Screen-level мутации карточки лимитной карты УП.
 */
export function useWsLimitCardMutations({
    onBoOperationSuccess,
}: UseWsLimitCardMutationsParams): UseWsLimitCardMutationsResult {
    const performBoOperationMutation = usePerformBoOperationMutation({
        scope: "wsLimitCard",
        onSuccess: onBoOperationSuccess,
    });

    return { performBoOperationMutation };
}
